import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { partnersList } from "../../../../data/mockData";
import "./gyannidashboard.css";
import Header from "../../../../components/Header";
import { ToastContainer, toast } from "react-toastify";
import Footer from "../../../../scenes/global/Footer";
import { fetchModuleByUserData } from "../../../../services/apiService";
import { PieChart } from "@mui/x-charts/PieChart";
import { Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../../scenes/global/Topbar";

const chartData = [
  { id: 0, value: 653215, label: "L&T SSC", color: "#4CAF50" },
  { id: 1, value: 222225, label: "TCS-ITC", color: "#FF5722" },
  { id: 2, value: 111115, label: "CIT-SEC", color: "#FFC107" },
  { id: 3, value: 111115, label: "iFIX", color: "#2196F3" },
  { id: 4, value: 15560, label: "HR BGV", color: "#9C27B0" },
  { id: 5, value: 25560, label: "3.o", color: "#009688" },
];

const xData = [0, 1, 2, 3, 4, 5, 6];
const yData = [1, 10, 30, 50, 70, 90, 100];

const AgentData = [
  { label: "Agent A", value: 400, color: "#4254fb" },
  { label: "Agent B", value: 300, color: "#ffb422" },
  { label: "Agent C", value: 300, color: "#fa4f58" },
  { label: "Agent D", value: 200, color: "#0dbeff" },
  { label: "Agent E", value: 278, color: "#22bf75" },
  { label: "Agent F", value: 189, color: "#fa83b4" },
];

const Gyaanidashboard = () => {
  const clientId = localStorage.getItem("clientId");
  const orgId = localStorage.getItem("organizationid");
  const UserId = localStorage.getItem("UserId");
  const storedToken = localStorage.getItem("token");
  const storedRoll = localStorage.getItem("role");
  const isAdmin = storedRoll?.toLowerCase() === "admin";

  const clientCode = localStorage.getItem("clientCode")?.toLowerCase();
  const isIfixSupport = clientCode === "ifixsupport" || clientCode === "stupa";

  let filteredData = chartData;

  try {
    const clientCode = localStorage.getItem("clientCode")?.toLowerCase() || "";

    // Check if clientCode means show all data
    const isIfixSupport =
      clientCode === "ifixsupport" || clientCode === "stupa";

    const labelMap = {
      "l&t ssc": "l&t ssc",
      "l&t hr bgv": "hr bgv",
      tcs: "tcs-itc",
      // "ifixsupport" is handled separately by isIfixSupport
    };

    if (!isIfixSupport) {
      // Filter by mapped label if exists
      const labelToMatch = labelMap[clientCode];
      if (labelToMatch) {
        filteredData = chartData.filter(
          (item) => item.label.toLowerCase() === labelToMatch
        );
      } else {
        // If no matching label, show empty or all? Your call.
        filteredData = [];
      }
    }
  } catch (error) {
    console.error("Error filtering chart data list:", error);
    filteredData = chartData; // fallback to all data
  }

  const legendConfig = {
    direction: "column",
    position: {
      vertical: "middle",
      horizontal:
        localStorage.getItem("clientCode")?.toLowerCase() === "ifixsupport" ||
        localStorage.getItem("clientCode")?.toLowerCase() === "stupa"
          ? "right"
          : "right",
    },
    padding: 10,
  };

  const [activeModules, setActiveModules] = useState([]);
  const [moduleUrl, setModuleUrl] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [bgColor, setBgColor] = useState("#fff");

  const [role, setRole] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const filteredData = await fetchModuleByUserData({
          clientid: Number(clientId),
          organizationid: Number(orgId),
          userid: Number(UserId),
        });

        if (filteredData.success) {
          const moduleList = filteredData.details;
          const preferredOrder = [
            "solution-gpt",
            "agentic-euc",
            "inspire",
            "ai-sm",
          ];

          const normalizedModules = moduleList.map((module) => ({
            name: module.modulename.trim().toLowerCase(),
            url: module.url,
          }));

          const activeModulesList = [];

          for (const name of preferredOrder) {
            const match = normalizedModules.find((m) => m.name === name);
            if (match) {
              activeModulesList.push({ name, url: match.url });
              if (!moduleUrl) {
                setModuleUrl(match.url);
              }
            }
          }

          setActiveModules(activeModulesList);
        } else {
          throw new Error("No module data found");
        }
      } catch (err) {
        console.error("Error fetching Module data:", err);
        setError("Failed to fetch Module data.");
        toast.error("Failed to fetch Module data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [clientId, orgId, storedToken, UserId]);

  useEffect(() => {
    const moduleNames = activeModules.map((module) => module.name);
    localStorage.setItem("ActiveModules", JSON.stringify(moduleNames));
  }, [activeModules]);

  const handleCardClick = (moduleName) => {
    const normalized = moduleName.toLowerCase().trim();
    const module = activeModules.find((mod) => mod.name === normalized);

    if (module?.url) {
      const urlWithToken = `${module.url}?token=${storedToken}`;
      window.open(urlWithToken, "_blank");
    } else {
      console.warn("Module not found:", normalized);
    }
  };

  const handlePartnersPage = () => {
    navigate("/Partners");
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  // graph modal pop

  const handleClick = (event, item) => {
    // console.log("Clicked:", item);
    setSelectedClient(item);
    setBgColor(item.color);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <Box m="10px">


        <div className="flex  relative p-10 mb-2">
          <Header
            title={
              <>
                Welcome to <span className="gyaani-gradient">GYAANi</span>
              </>
            }
            subtitle="Crafted in India, Designed for the World."
          />

          <div className="absolute right-0">
            <Topbar />
          </div>
        </div>

        {(storedRoll === "Admin" ||
          storedRoll === "Super Admin" ||
          storedRoll === "SuperAdmin") && (
          <>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6 text-center">
                <h5 className="text-lg font-semibold text-black">
                  Client's Users Details
                </h5>
                <div className="flex justify-center items-center">
                  <div
                    onClick={(e) => handleClick(e, { label: "L&T SSC" })}
                    className={`cursor-pointer animationDiv ${isAdmin ? "admin" : ""}`}
                  >
                    <PieChart
                      series={[
                        {
                          data: filteredData,
                          innerRadius: 30,
                          outerRadius: 100,
                          paddingAngle: 5,
                          cornerRadius: 5,
                          startAngle: -45,
                          endAngle: 225,
                          cx: 120,
                          cy: 150,
                        },
                      ]}
                      width={400}
                      height={300}
                      slotProps={{ legend: "right" }}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="col-span-2 text-center">
                <div className="relative break-words print:border card rounded-lg border border-gray-200 dark:border-dark-600 print:border-0 px-4 pb-4 sm:px-5">
                  {(storedRoll === "Super Admin" ||
                    storedRoll === "SuperAdmin") && (
                    <>
                      <div
                        className="cursor-pointer h-14 py-3"
                        onClick={handlePartnersPage}
                      >
                        <h5 className="text-lg font-semibold text-black text-center">
                          Partner's List
                        </h5>
                      </div>
                      <div className="rounded-md overflow-x-auto">
                        {partnersList.map((transaction, i) => (
                          <div
                            key={i}
                            className="flex justify-between items-center border-b border-dashed py-2"
                          >
                            <span className="text-gray-300 font-medium">
                              {transaction.name}
                            </span>
                            <span
                              className={`px-2 py-1 rounded ${
                                transaction.status === "Active"
                                  ? "bg-green-100 text-green-500"
                                  : "bg-red-100 text-red-500"
                              }`}
                            >
                              {transaction.status}
                            </span>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div> */}

              <div className="col-span-6 grid grid-cols-6 gap-4">
                {(storedRoll === "Super Admin" ||
                  storedRoll === "SuperAdmin") && (
                  <>
                    <div className="col-span-3 -mt-5">
                      <div className="bg-blue shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                        <h5 className="text-lg font-semibold text-gray-800 mb-2">
                          Connected Minute - Solution GPT
                        </h5>
                        <p className="text-2xl font-bold">1,642 min</p>
                        <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                          <div
                            className="bg-yellow-400 h-2 rounded-full"
                            style={{ width: "75%" }}
                          ></div>
                        </div>
                        <p className="text-sm text-red-500 mt-2">
                          ↓ 1.15% since last week
                        </p>
                      </div>
                    </div>
                    <div className="col-span-3">
                      <div className="bg-white shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                        <h5 className="text-lg font-semibold text-gray-800 mb-2">
                          Connected Minute - Agentic EUC
                        </h5>
                        <p className="text-2xl font-bold">3,642</p>
                        <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                          <div
                            className="bg-sky-400 h-2 rounded-full"
                            style={{ width: "65%" }}
                          ></div>
                        </div>
                        <p className="text-sm text-green-600 mt-2">
                          ↑ 2.37% since last week
                        </p>
                      </div>
                    </div>
                    <div className="col-span-3">
                      <div className="bg-white shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                        <h5 className="text-lg font-semibold text-gray-800 mb-2">
                          Number of Agents
                        </h5>
                        <p className="text-2xl font-bold">1,041</p>
                        <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                          <div
                            className="bg-green-400 h-2 rounded-full"
                            style={{ width: "85%" }}
                          ></div>
                        </div>
                        <p className="text-sm text-green-600 mt-2">
                          ↑ 3.77% since April 2025
                        </p>
                      </div>
                    </div>
                    <div className="col-span-3">
                      <div className="bg-white shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                        <h5 className="text-lg font-semibold text-gray-800 mb-2">
                          Number of Tokens
                        </h5>
                        <p className="text-2xl font-bold">2,150</p>
                        <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                          <div
                            className="bg-blue-400 h-2 rounded-full"
                            style={{ width: "55%" }}
                          ></div>
                        </div>
                        <p className="text-sm text-green-600 mt-2">
                          ↑ 4.82% since May 2025
                        </p>
                      </div>
                    </div>
                  </>
                )}

                {storedRoll === "admin" ||
                  (storedRoll === "Admin" && (
                    <>
                      <div className="col-span-3 -mt-5">
                        <div className="bg-green shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                          <h5 className="text-lg font-semibold text-gray-800 mb-2">
                            Active Users (Last 90 Days)
                          </h5>
                          <p className="text-2xl font-bold">13,641</p>
                          <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                            <div
                              className="bg-green-400 h-2 rounded-full"
                              style={{ width: "75%" }}
                            ></div>
                          </div>
                          <p className="text-sm text-red-500 mt-2">
                          ↑ 8.3% increase from previous period (12,582 users)
                          </p>
                        </div>
                      </div>
                      <div className="col-span-3">
                        <div className="bg-white shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                          <h5 className="text-lg font-semibold text-gray-800 mb-2">
                            Inactive Users
                          </h5>
                          <p className="text-2xl font-bold">6,39,574</p>
                          <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                            <div
                              className="bg-red-400 h-2 rounded-full"
                              style={{ width: "65%" }}
                            ></div>
                          </div>
                          <p className="text-sm text-green-600 mt-2">
                          ↓ 5.4% decrease since last quarter
                          </p>
                        </div>
                      </div>

                      <div className="col-span-3">
                        <div className="bg-white shadow rounded-md p-4 duration-300 ease-in hover:scale-105 hover:-translate-y-1 hover:shadow-[0_5px_15px_#00bcd450] transition-all duration-300 ease-in-out">
                          <h5 className="text-lg font-semibold text-gray-800 mb-2">
                            Total Users
                          </h5>
                          <p className="text-2xl font-bold">6,53,215</p>
                          <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                            <div
                              className="bg-blue-400 h-2 rounded-full"
                              style={{ width: "65%" }}
                            ></div>
                          </div>
                          <p className="text-sm text-green-600 mt-2">
                          ↑ 2.1% growth compared to last year
                          </p>
                        </div>
                      </div>
                    </>
                  ))}
              </div>

              <div className="col-span-6 grid grid-cols-6 gap-4"></div>
            </div>
          </>
        )}
      </Box>
      {/* ROW 2 */}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
        {Array.isArray(activeModules) &&
          activeModules
            .map((module) => module.name.trim())
            .includes("solution-gpt") && (
            <div className="col-span-1">
              <div
                className={`card cursor-pointer shadow-lg mb-4 border-none transition-all duration-300 ease-in-out letter-spacing-[0.5px] rounded-lg transform hover:translate-y-[-5px] border-custom`}
                style={{ backgroundColor: colors.primary[400] }}
                onClick={() => handleCardClick("solution-gpt")}
              >
                <div className="card-body p-2 flex items-center gap-4">
                  <div className="widget-icon p-2 shadow-lg rounded-full">
                    <img
                      src="https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/freepik__background__20610.png?updatedAt=1747297047839"
                      alt="Gyaani - auto-learn"
                      className="w-20 h-20"
                    />
                  </div>
                  <div style={{ color: colors.grey[100] }}>
                    <h3 className="text-xl font-semibold">Solution GPT</h3>
                    <span className="text-sm font-light text-gray-500">
                      Powered by GYAANi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

        {/* Agentic EUC Card */}
        {Array.isArray(activeModules) &&
          activeModules
            .map((module) => module.name.trim())
            .includes("agentic-euc") && (
            <div className="col-span-1">
              <div
                className={`card cursor-pointer shadow-lg mb-4 border-none transition-all duration-300 ease-in-out letter-spacing-[0.5px] rounded-lg transform hover:translate-y-[-5px] border-custom`}
                style={{ backgroundColor: colors.primary[400] }}
                onClick={() => handleCardClick("agentic-euc")}
              >
                <div className="card-body p-2 flex items-center gap-4">
                  <div className="widget-icon p-2 shadow-lg rounded-full">
                    <img
                      src="https://ik.imagekit.io/ifixtechglobal/gyanni-work-bot/11.png?updatedAt=1702356908544"
                      alt="Agentic EUC"
                      className="w-24 h-24"
                    />
                  </div>
                  <div style={{ color: colors.grey[100] }}>
                    <h3 className="text-xl font-semibold">Agentic EUC</h3>
                    <span className="text-sm font-light text-gray-500">
                      Powered by GYAANi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

        {/* ai-SM Card */}
        {Array.isArray(activeModules) &&
          activeModules
            .map((module) => module.name.trim())
            .includes("ai-sm") && (
            <div className="col-span-1">
              <div
                className="card cursor-pointer shadow-lg mb-4 border-none transition-all duration-300 ease-in-out letter-spacing-[0.5px] rounded-lg transform hover:translate-y-[-5px] border-custom"
                style={{ backgroundColor: colors.primary[400] }}
                onClick={() => handleCardClick("ai-sm")}
              >
                <div className="card-body p-2 flex items-center gap-4">
                  <div className="widget-icon p-2 shadow-lg rounded-full">
                    <img
                      src="https://ik.imagekit.io/ifixtechglobal/gyanni-work-bot/13.png?updatedAt=1702356942726"
                      alt="Gyaani - ai-sm"
                      className="w-24 h-24"
                    />
                  </div>
                  <div style={{ color: colors.grey[100] }}>
                    <h3 className="text-xl font-semibold">ai-SM</h3>
                    <span className="text-sm font-light text-gray-500">
                      Powered by GYAANi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

        {/* API Integration Card */}
        {Array.isArray(activeModules) &&
          activeModules
            .map((module) => module.name.trim())
            .includes("api-Integration") && (
            <div className="col-span-1">
              <div
                className="card cursor-pointer shadow-lg mb-4 border-none transition-all duration-300 ease-in-out letter-spacing-[0.5px] rounded-lg transform hover:translate-y-[-5px] border-custom"
                style={{ backgroundColor: colors.primary[400] }}
                onClick={() => handleCardClick("api-Integration")}
              >
                <div className="card-body p-2 flex items-center gap-4">
                  <div className="widget-icon p-2 shadow-lg rounded-full">
                    <img
                      src="https://ik.imagekit.io/ifixtechglobal/gyanni-work-bot/17.png?updatedAt=1702357008133"
                      alt="Gyaani - API Integration"
                      className="w-24 h-24"
                    />
                  </div>
                  <div style={{ color: colors.grey[100] }}>
                    <h3 className="text-xl font-semibold">API Integration</h3>
                    <span className="text-sm font-light text-gray-500">
                      Powered by GYAANi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

        {/* iNSPIRE Card */}
        {Array.isArray(activeModules) &&
          activeModules
            .map((module) => module.name.trim().toLowerCase())
            .includes("inspire") && (
            <div className="col-span-1">
              <div
                className="card cursor-pointer shadow-lg mb-4 border-none transition-all duration-300 ease-in-out letter-spacing-[0.5px] rounded-lg transform hover:translate-y-[-5px] border-custom"
                style={{ backgroundColor: colors.primary[400] }}
                onClick={() => handleCardClick("iNSPIRE")}
              >
                <div className="card-body p-2 flex items-center gap-4">
                  <div className="widget-icon p-2 shadow-lg rounded-full">
                    <img
                      src="https://ik.imagekit.io/ifixtechglobal/gyanni-work-bot/12.png?updatedAt=1702356942685"
                      alt="Gyaani - iNSPIRE"
                      className="w-24 h-24"
                    />
                  </div>
                  <div style={{ color: colors.grey[100] }}>
                    <h3 className="text-xl font-semibold">iNSPIRE</h3>
                    <span className="text-sm font-light text-gray-500">
                      Powered by GYAANi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            p: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: 24,
            width: 400,
            margin: "auto",
            mt: "15%",
          }}
        >
          <Typography variant="h6" align="center" sx={{ mb: 2 }}>
            {selectedClient?.label} - User Details
          </Typography>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "left",
                    padding: "8px",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    textAlign: "right",
                    padding: "8px",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  Count
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "8px" }}>
                  <Typography> Active Users (Last 90 Days)</Typography>
                </td>
                <td style={{ textAlign: "right", padding: "8px" }}>
                  <Typography>13,641</Typography>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>
                  <Typography> Inactive Users</Typography>
                </td>
                <td style={{ textAlign: "right", padding: "8px" }}>
                  <Typography>6,39,574</Typography>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>
                  <Typography>Total Users</Typography>
                </td>
                <td style={{ textAlign: "right", padding: "8px" }}>
                  <Typography>6,53,215</Typography>
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
      </Modal>

      <ToastContainer />

      <Footer />
    </>
  );
};

export default Gyaanidashboard;
